var hashtag_default = {
  "fontElementMap": "IJkhF",
  "hashtag": "PQUVt"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
